import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 決算締め状態 */
enum ClosingStatus {
  normal = 'NORMAL',
  provisionalCutoff = 'PROVISIONAL_CUTOFF',
  finalCutoff = 'FINAL_CUTOFF',
  afterClosing = 'AFTER_CLOSING',
  beforeStartOfFiscalYear = 'BEFORE_START_OF_FISCAL_YEAR',
}

const nameConfig = {
  normal: new Map([
    [Locale.ja, '通常'],
    [Locale.en, 'Normal'],
  ]),
  provisionalCutoff: new Map([
    [Locale.ja, '仮締め'],
    [Locale.en, 'Provisional Cutoff'],
  ]),
  finalCutoff: new Map([
    [Locale.ja, '本締め'],
    [Locale.en, 'Final Cutoff'],
  ]),
  afterClosing: new Map([
    [Locale.ja, '確定後'],
    [Locale.en, 'After Closing'],
  ]),
  beforeStartOfFiscalYear: new Map([
    [Locale.ja, '年度開始前'],
    [Locale.en, 'Before Start Of Fiscal Year'],
  ]),
};

const toEnum = rawValueToEnum(ClosingStatus, ClosingStatus.normal);
const toDisplay = enumToName(ClosingStatus, nameConfig);
const toDisplayWithPrefix = enumToName(ClosingStatus, nameConfig, { prefix: true });

export const closingStatus = {
  enum: ClosingStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ClosingStatus };
